import getComponent from './get-component';

const getFileTypes = () => {
  const component = getComponent();
  return component.getFileTypes();
};

export default getFileTypes;
